import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import CloudCMAWidget from '@components/widget/CloudCMAWidget';
import TrainingWidget from '@components/widget/TrainingWidget';

const CloudCMA = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-cloud mr-2" />
        Cloud CMA
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <CloudCMAWidget />
        </Panel>
      </div>
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <TrainingWidget url="https://pillarnine.com/p9premiumtools" />
        </Panel>
      </div>
    </div>
  </>
);

export default CloudCMA;
